import { logEvent } from "firebase/analytics";
import { User } from "firebase/auth";
import { useCallback } from "react";
import {
  analytics,
  setUserAnalyticsProperties,
} from "@/integrations/firebase/analytics";

export interface useAnalyticsProps {
  logEvent: (eventName: string, eventParams?: Record<string, unknown>) => void;
  setUserAnalyticsProperties: (user: User) => void;
}

export function useAnalytics(): useAnalyticsProps {
  const trackEvent = useCallback(
    (eventName: string, eventParams?: Record<string, unknown>) => {
      try {
        if (analytics) {
          logEvent(analytics, eventName, eventParams);
        }
      } catch (error) {
        console.error("Failed to log GA event:", error);
      }
    },
    [],
  );

  const setUserProperties = useCallback((user: User) => {
    setUserAnalyticsProperties(user);
  }, []);

  return {
    logEvent: trackEvent,
    setUserAnalyticsProperties: setUserProperties,
  };
}
